/* Product page: gallery, variants with real stock, add to cart, sticky buy bar, ask / back-in-stock forms,
   size comparison, wishlist and "you might also like". All wording comes from the section settings (JSON in the page). */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => (reduce.matches ? 'auto' : 'smooth');
  let TEXT = {};
  let toastEl = null;
  let toastTimer;

  function toast(msg) {
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('on'), 2600);
  }

  /* ---------- Main product section ---------- */
  function setupMain(root) {
    if (root.__cp) return;
    root.__cp = true;
    const data = JSON.parse(root.querySelector('[data-cp-data]').textContent);
    TEXT = data.text;
    toastEl = root.querySelector('[data-cp-toast]');
    const variants = data.variants;
    let sel = (variants.find((v) => v.id === data.currentId) || variants[0]).options.slice();
    let current = variants.find((v) => v.id === data.currentId) || variants[0];

    const $ = (s) => root.querySelector(s);
    const slides = $('[data-cp-slides]');
    const thumbs = $('[data-cp-thumbs]');
    const dots = $('[data-cp-dots]');
    const priceEl = $('[data-cp-price]');
    const compareEl = $('[data-cp-compare]');
    const saveEl = $('[data-cp-save]');
    const stockEl = $('[data-cp-stock]');
    const idInput = $('[data-cp-variant]');
    const addBtn = $('[data-cp-add]');
    const add2 = $('[data-cp-add2]');
    const sticky = $('[data-cp-sticky]');
    const form = $('#cv-p-form');
    const groups = [...root.querySelectorAll('[data-cp-option]')];
    const fallback = $('[data-cp-fallback]');
    const mode = root.dataset.restockMode || 'stoq';
    const waitMs = (parseFloat(root.dataset.fallbackWait) || 3) * 1000;
    let fbTimer;

    /* gallery: the photos of the selected colour (its Variant Gallery); the rest stay hidden until another colour is picked */
    const allSlides = [...slides.querySelectorAll('.cv-p__slide')];
    const allThumbs = [...thumbs.children];
    const visible = (list) => list.filter((el) => !el.hidden);
    function mark(i) {
      visible(allThumbs).forEach((b, j) => b.setAttribute('aria-current', j === i));
      [...dots.children].forEach((d, j) => d.classList.toggle('on', j === i));
    }
    function go(i, instant) {
      slides.scrollTo({ left: i * slides.clientWidth, behavior: instant ? 'auto' : behavior() });
      mark(i);
    }
    function showGallery(v) {
      const ids = v.gallery && v.gallery.length ? v.gallery : data.allMedia;
      const bySlide = new Map(allSlides.map((el) => [+el.dataset.mediaId, el]));
      const byThumb = new Map(allThumbs.map((el) => [+el.dataset.mediaId, el]));
      const on = new Set();
      ids.forEach((id, i) => {
        const s = bySlide.get(id);
        const b = byThumb.get(id);
        if (!s || !b) return;
        on.add(id);
        s.hidden = false;
        b.hidden = false;
        s.dataset.i = i;
        b.dataset.i = i;
        slides.appendChild(s);
        thumbs.appendChild(b);
      });
      allSlides.forEach((s) => { if (!on.has(+s.dataset.mediaId)) s.hidden = true; s.classList.remove('zoom'); });
      allThumbs.forEach((b) => { if (!on.has(+b.dataset.mediaId)) b.hidden = true; });
      const first = visible(allSlides)[0];
      const img = first && first.querySelector('img');
      if (img) img.loading = 'eager';
      dots.innerHTML = visible(allSlides).map(() => '<i></i>').join('');
      visible(allThumbs).forEach((b, j) => b.setAttribute('aria-label', (b.getAttribute('aria-label') || '').replace(/\d+/, j + 1)));
    }
    thumbs.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (b) go(+b.dataset.i);
    });
    slides.addEventListener('scroll', () => mark(Math.round(slides.scrollLeft / slides.clientWidth)), { passive: true });
    slides.addEventListener('click', (e) => {
      const s = e.target.closest('.cv-p__slide');
      if (!s || s.classList.contains('cv-p__slide--media') || window.matchMedia('(max-width: 900px)').matches) return;
      const img = s.querySelector('img');
      if (!img) return;
      const r = s.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      s.classList.toggle('zoom');
    });

    /* variants */
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    function paintOptions() {
      groups.forEach((g, i) => {
        g.querySelectorAll('.cv-p__swbtn').forEach((btn) => {
          const val = btn.dataset.value;
          btn.setAttribute('aria-pressed', sel[i] === val);
          const open = variants.some((v) => v.options[i] === val && v.available && v.options.every((o, j) => j === i || o === sel[j]));
          btn.classList.toggle('out', !open);
        });
        const label = root.querySelector('[data-cp-optname="' + i + '"]');
        if (label) label.textContent = sel[i];
      });
    }
    // Stoq (a back-in-stock app) puts its own "Notify me" button in place of a disabled Add to cart. If it does not show up
    // in time, or the simple-form mode is chosen, our own "Email me when it's back" button is used.
    const stoqVisible = () =>
      [...document.querySelectorAll('[class*="stoq" i], [id*="stoq" i], [class*="rocket" i], [id*="rocket" i]')].some(
        (el) => !/^(SCRIPT|STYLE|LINK|META)$/.test(el.tagName) && el.getClientRects().length > 0 && el.offsetHeight > 0
      );
    function setButtons(v) {
      const stoq = mode === 'stoq';
      [addBtn, add2].forEach((b) => {
        if (!b) return;
        if (v.available) {
          b.dataset.state = 'add';
          b.textContent = TEXT.add;
          b.disabled = false;
        } else if (b === addBtn && stoq) {
          b.dataset.state = 'soldout';
          b.textContent = TEXT.soldOut;
          b.disabled = true;
        } else {
          b.dataset.state = 'restock';
          b.textContent = TEXT.restock;
          b.disabled = false;
        }
      });
      clearTimeout(fbTimer);
      if (fallback) {
        fallback.hidden = true;
        if (!v.available && stoq) {
          fbTimer = setTimeout(() => {
            if (!current.available) fallback.hidden = stoqVisible();
          }, waitMs);
        }
      }
    }
    function update(v, opts = {}) {
      current = v;
      sel = v.options.slice();
      idInput.value = v.id;
      // Tell back-in-stock apps (Stoq) that the variant changed, the way themes normally do.
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: v.id, available: v.available } } }));
      priceEl.textContent = v.price;
      const ptsEl = $('[data-cp-points]');
      if (ptsEl && TEXT.pointsText) {
        ptsEl.textContent = TEXT.pointsText.replace('[points]', v.points);
        ptsEl.hidden = !(v.points > 0);
      }
      if (compareEl) {
        compareEl.textContent = v.compare;
        compareEl.hidden = !v.compare;
      }
      if (saveEl) {
        saveEl.textContent = TEXT.saveLabel.replace('[amount]', v.save);
        saveEl.hidden = !v.compare;
      }
      stockEl.classList.toggle('no', !v.available);
      stockEl.querySelector('span').textContent = !v.available ? TEXT.stockOut : v.qty === 1 ? TEXT.stockLast : TEXT.stockIn;
      setButtons(v);
      paintOptions();
      const sp = $('[data-cp-sprice]');
      if (sp) sp.textContent = v.price + (data.hasOnlyDefault ? '' : ' · ' + v.title);
      const st = $('.cv-sticky__img');
      if (st && v.img) st.src = v.img;
      const intro = $('[data-cp-restock-intro]');
      if (intro) intro.textContent = TEXT.restockIntro.replace('[variant]', v.title);
      const rv = $('[data-cp-restock-variant]');
      if (rv) rv.value = v.title;
      if (opts.url !== false) {
        try {
          const u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(null, '', u);
        } catch (e) {}
      }
      showGallery(v);
      if (v.gallery && v.gallery.length) {
        go(0, true);
      } else if (opts.scroll !== false && v.media) {
        const i = visible(allSlides).findIndex((s) => +s.dataset.mediaId === v.media);
        go(i > -1 ? i : 0, opts.instant);
      } else {
        go(0, true);
      }
    }
    groups.forEach((g, i) =>
      g.addEventListener('click', (e) => {
        const btn = e.target.closest('.cv-p__swbtn');
        if (!btn) return;
        const test = sel.slice();
        test[i] = btn.dataset.value;
        const v = findVariant(test) || variants.find((x) => x.options[i] === btn.dataset.value);
        if (v) update(v);
      })
    );
    update(current, { url: false, scroll: new URLSearchParams(location.search).has('variant'), instant: true });

    /* add to cart (uses the theme's cart drawer / notification) */
    function addToCart() {
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      addBtn.setAttribute('aria-disabled', 'true');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(form);
      if (cart) {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = body;
      fetch(window.routes.cart_add_url, config)
        .then((r) => r.json())
        .then((res) => {
          if (res.status) throw new Error(res.description || res.message || 'Could not add');
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cv-product', productVariantId: body.get('id'), cartData: res });
          }
          cart.renderContents(res);
          toast(TEXT.toastAdded);
        })
        .catch(() => toast(TEXT.toastError))
        .finally(() => addBtn.removeAttribute('aria-disabled'));
    }
    function toBuyBox() {
      const box = root.querySelector('.cv-p__cta') || addBtn;
      box.scrollIntoView({ behavior: behavior(), block: 'center' });
    }
    function buy() {
      if (!current.available) return mode === 'stoq' ? toBuyBox() : openDialog('restock');
      addToCart();
    }
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      buy();
    });
    if (add2) add2.addEventListener('click', buy);

    if (location.hash === '#notify' && !current.available) setTimeout(toBuyBox, 400);

    /* sticky buy bar: shows once the main Add to cart button has scrolled out of sight (above the screen).
       Checked on scroll, once per frame, so a fast jump past the button (a reload at a scrolled position, an anchor link, a fling) still shows it. */
    if (sticky) {
      let ticking = false;
      let isOn = null;
      const check = () => {
        ticking = false;
        const on = addBtn.getBoundingClientRect().bottom < 0;
        if (on === isOn) return;
        isOn = on;
        sticky.classList.toggle('on', on);
        sticky.setAttribute('aria-hidden', !on);
        if (add2) add2.tabIndex = on ? 0 : -1;
        // keep the end of the page reachable: while the bar is showing the page gets room for it
        document.documentElement.style.setProperty('--cv-sticky-h', on ? sticky.offsetHeight + 'px' : '0px');
        document.documentElement.classList.toggle('cv-sticky-on', on);
      };
      const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      window.addEventListener('load', request);
      check();
    }

    /* dialogs: ask a question, back in stock (Shopify's contact form, sent by email) */
    function openDialog(name) {
      const d = root.querySelector('[data-cp-dialog="' + name + '"]');
      if (d && d.showModal) d.showModal();
    }
    root.addEventListener('click', (e) => {
      const o = e.target.closest('[data-cp-open]');
      if (o) return openDialog(o.dataset.cpOpen);
      if (e.target.closest('[data-cp-close]')) {
        const d = e.target.closest('dialog');
        if (d) d.close();
        return;
      }
      if (e.target.tagName === 'DIALOG') e.target.close(); // click on the backdrop
    });
    root.querySelectorAll('dialog form').forEach((f) => {
      f.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = f.querySelector('[type="submit"]');
        const err = f.querySelector('[data-cp-err]');
        if (err) err.hidden = true;
        btn.setAttribute('aria-disabled', 'true');
        const isRestock = f.id === 'cv-restock-form';
        fetch(f.action, { method: 'POST', body: new FormData(f), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((res) => {
            if (res.url && res.url.indexOf('contact_posted=true') > -1) {
              f.closest('dialog').close();
              f.reset();
              toast(isRestock ? TEXT.toastRestockSent : TEXT.toastAskSent);
            } else if (res.url && res.url.indexOf('challenge') > -1) {
              f.submit(); // Shopify wants its spam check: let the normal form handle it
            } else {
              throw new Error('not sent');
            }
          })
          .catch(() => {
            if (err) err.hidden = false;
          })
          .finally(() => btn.removeAttribute('aria-disabled'));
      });
    });
  }

  /* ---------- Size comparison (drawn from the case-size fields) ---------- */
  function setupSize(sec) {
    const box = sec.querySelector('[data-cs-scale]');
    if (!box || box.__cs) return;
    box.__cs = true;
    const g = box.querySelector('[data-cs-cases]');
    const W = parseFloat(box.dataset.w);
    const L = parseFloat(box.dataset.l) || W;
    const shape = box.dataset.shape || 'round';
    const K = 4; // pixels per millimetre
    const fmt = (n) => String(Math.round(n * 100) / 100);
    const svg = box.querySelector('svg');
    const maxMm = Math.max(0, ...[...box.querySelectorAll('[data-mm]')].map((x) => parseFloat(x.dataset.mm) || 0));
    function draw(mm) {
      const a = (W * K) / 2;
      const b = (mm * K) / 2;
      const half = (shape === 'round' ? W : L) * K / 2;
      const rx = shape === 'tonneau' ? a * 0.55 : shape === 'square' ? a * 0.25 : a * 0.12;
      // the tallest thing in the drawing decides how much room it needs above and below
      const ext = Math.max(half, a, (maxMm * K) / 2);
      const top = 110 - ext - 26; // room for the watch size label
      const capY = 110 + ext + 28; // the caption sits under everything, with clear space
      const bottom = capY + 14;
      // the coin is drawn at the same scale on the right (centre 130, see the section), so keep it inside too
      svg.setAttribute('viewBox', '0 ' + Math.min(-14, top) + ' 420 ' + (Math.max(236, bottom) - Math.min(-14, top)));
      g.innerHTML =
        (shape === 'round'
          ? '<circle cx="150" cy="110" r="' + a + '" fill="rgba(255,255,255,.55)" stroke="#121212" stroke-width="1.6"/>'
          : '<rect x="' + (150 - a) + '" y="' + (110 - half) + '" width="' + a * 2 + '" height="' + half * 2 + '" rx="' + rx + '" fill="rgba(255,255,255,.55)" stroke="#121212" stroke-width="1.6"/>') +
        '<circle cx="150" cy="110" r="' + a * 0.72 + '" fill="none" stroke="#121212" stroke-width=".8" opacity=".35"/>' +
        '<circle cx="150" cy="110" r="' + b + '" fill="rgba(18,18,18,.06)" stroke="#5f5f5f" stroke-width="1.4" stroke-dasharray="5 4"/>' +
        '<text x="150" y="' + (110 - ext - 10) + '" text-anchor="middle" font-family="Funnel Sans,Arial" font-size="12" font-weight="600"></text>' +
        '<text x="150" y="' + capY + '" text-anchor="middle" font-family="Funnel Sans,Arial" font-size="11" fill="#5f5f5f"></text>';
      const t = g.querySelectorAll('text');
      t[0].textContent = (box.dataset.label || '[size] mm').replace('[size]', fmt(W));
      t[1].textContent = (box.dataset.caption || '[mm] mm').replace('[mm]', fmt(mm));
    }
    const first = box.querySelector('[aria-pressed="true"]') || box.querySelector('[data-mm]');
    draw(parseFloat(first ? first.dataset.mm : box.dataset.default) || 42);
    box.querySelector('.cv-scale__toggle').addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      box.querySelectorAll('.cv-scale__toggle button').forEach((x) => x.setAttribute('aria-pressed', x === b));
      draw(parseFloat(b.dataset.mm));
    });
  }

  /* ---------- You might also like (Shopify's product recommendations) ---------- */
  function setupRelated(sec) {
    if (sec.__rel) return;
    sec.__rel = true;
    if (sec.querySelector('.cv-rel__grid')) return;
    fetch(sec.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-cp-related]');
        if (next && next.querySelector('.cv-rel__grid')) {
          sec.innerHTML = next.innerHTML;
        } else {
          sec.remove();
        }
      })
      .catch(() => sec.remove());
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cp-root]').forEach(setupMain);
    scope.querySelectorAll('[data-cp-size]').forEach(setupSize);
    scope.querySelectorAll('[data-cp-related]').forEach(setupRelated);
  };
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  init();
})();
